export const featuredPlatforms = [
  {
    name: "Textile Today",
    description:
      "A leading media, communication and networking platform functioning as an Innovation Hub.",
    icon: "ri-article-line",
    logo: "https://storage.helloreaddy.io/project_files/3695ba64-190a-4f8e-a9e2-04b761fa00c1/080b215a-d1d3-4ff2-9067-2589707080ef_compressed_logo-3.webp",
    link: "https://www.textiletoday.com.bd/",
    cta: "Visit Textile Today",
  },
  {
    name: "Textile Today Training",
    description:
      "A dedicated platform for industry training and capacity building.",
    icon: "ri-user-star-line",
    logo: "https://storage.helloreaddy.io/project_files/3695ba64-190a-4f8e-a9e2-04b761fa00c1/ff3fcf66-15c5-4ff0-9d84-c12a5f1256d6_compressed_Textile-Today-Training.webp",
    link: "https://training.textiletoday.com.bd/",
    cta: "Explore Training",
  },
  {
    name: "Textile Today Innovation Hub (TTIH)",
    description:
      "A&J-owned innovation platform focused on practical innovation, industry transformation, capability development and innovation projects.",
    icon: "ri-lightbulb-line",
    logo: "https://storage.helloreaddy.io/project_files/3695ba64-190a-4f8e-a9e2-04b761fa00c1/b3887ba1-7acf-43d9-82c3-40a02ca397e8_compressed_innovation.webp",
    link: "https://www.textiletoday.com.bd/topics/textile-today-innovation-hub",
    owned: true,
  },
  {
    name: "TexSPACE Today",
    description: "Specialized publication and platform.",
    icon: "ri-book-open-line",
    logo: "https://storage.helloreaddy.io/project_files/3695ba64-190a-4f8e-a9e2-04b761fa00c1/a7fab7a9-eb2f-4659-ae26-cfab1b5ce3d8_compressed_TexSPACE-Today-Logo.webp",
    link: "https://www.texspacetoday.com/",
    cta: "Visit TexSPACE Today",
  },
  {
    name: "Muslin",
    description:
      "Publication within the wider media and publication portfolio.",
    icon: "ri-book-2-line",
    logo: "https://storage.helloreaddy.io/project_files/3695ba64-190a-4f8e-a9e2-04b761fa00c1/534cf07b-f06a-4a39-a6b5-403bef5ac1af_compressed_Screenshot_209.webp",
    link: "https://www.muslin.com.bd",
    cta: "Visit Muslin",
  },
];

export const majorInitiatives = [
  {
    name: "Textile Talent Hunt (TTH)",
    tag: "Talent → Training → Innovation → Industry",
    description:
      "A talent grooming and innovation-focused competition designed to prepare future leaders through training, mentoring, industry engagement and practical innovation projects.",
    icon: "ri-trophy-line",
    logo: "https://storage.helloreaddy.io/project_files/3695ba64-190a-4f8e-a9e2-04b761fa00c1/f703cd81-9d18-4c83-8d0e-30976952ec64_compressed_Screenshot_208.webp",
    link: "https://textiletalenthunt.com/",
    cta: "Visit TTH",
  },
  {
    name: "Textile Innovation Awards",
    category: "Awards & Recognition",
    description:
      "Recognizing measurable innovation and meaningful contributions to textile and apparel industry development.",
    icon: "ri-medal-line",
    logo: "https://storage.helloreaddy.io/project_files/3695ba64-190a-4f8e-a9e2-04b761fa00c1/acb990ab-6498-4bc8-a4b3-bb4ca8d2ca39_compressed_Innovation-Awards-removebg-preview-1-1.webp",
    link: "https://innovation-awards.textiletoday.com.bd/",
    cta: "Visit Awards",
  },
];

export const otherInitiatives = [
  {
    name: "TexTIME",
    link: "https://www.youtube.com/live/tdNhfVw4KeY?si=WEQQjlI73w8Mbjr2",
  },
  { name: "Innovation projects" },
  { name: "Research initiatives" },
  { name: "Competitions" },
  { name: "Awards" },
  { name: "International delegations" },
  { name: "Factory visits" },
  { name: "Industry programmes" },
];